import { useCallback, useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { ConfigContext } from '@/components/ConfigProvider';
import { isValidClusterName } from '@/utils/tenantClusterStorage';

const getval = (data, defaultVal) => {
  if (!data?.length) return { _cluster: defaultVal };
  return { _cluster: data?.[0]?.name || ':cluster' };
};

// 获取默认集群
function useClusters() {
  const params = useParams();
  const routeCluster = params?.cluster;
  const { clusterList, cluster, setCluster } = useContext(ConfigContext);

  const setCluster0 = useCallback(
    (v) => {
      if (!isValidClusterName(v) || typeof setCluster !== 'function') return;
      setCluster(v);
      localStorage.setItem('cluster', JSON.stringify(v));
    },
    [setCluster],
  );

  // useParams() 返回值引用不稳定；且 URL 中的 "undefined" 不能写入全局 cluster。
  useEffect(() => {
    if (isValidClusterName(routeCluster) && routeCluster !== cluster) {
      setCluster0(routeCluster);
    }
  }, [routeCluster, cluster, setCluster0]);

  useEffect(() => {
    if (isValidClusterName(cluster)) return;
    const { _cluster } = getval(clusterList, '');
    if (isValidClusterName(_cluster) && _cluster !== cluster) {
      setCluster0(_cluster);
    }
  }, [cluster, clusterList, setCluster0]);

  return { cluster, clusterList, setCluster: setCluster0 };
}
export default useClusters;
